import { ActionIcon, Button } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { ChangeEvent, forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

import {
  FileUploadButtonRef,
  Props,
} from 'src/Components/Shared/FileUploadButton/FileUploadButton.types';

const FileUploadButton = forwardRef<FileUploadButtonRef, Props>(function FileUploadButton(
  { label, accept, onSelect, compact, multiple, triggerOpen, ...props },
  ref
) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  useImperativeHandle(ref, () => ({
    openFilePicker: handleButtonClick,
  }));

  useEffect(() => {
    if (triggerOpen) {
      handleButtonClick();
    }
  }, [triggerOpen]);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      onSelect(files);
    }
  };

  return (
    <>
      {compact ? (
        <ActionIcon radius={'xl'} size={'lg'} onClick={handleButtonClick}>
          <IconUpload size={20} />
        </ActionIcon>
      ) : (
        <Button {...props} onClick={handleButtonClick}>
          {label}
        </Button>
      )}

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept={accept}
        multiple={multiple}
      />
    </>
  );
});

export default FileUploadButton;
